import { http, createConfig } from 'wagmi'
import { mainnet, polygon } from 'wagmi/chains'
import { injected } from 'wagmi/connectors'

const getSelectedInjectedProvider = () => {
  if (typeof window === 'undefined') return undefined
  return window.__PINGUI_SELECTED_PROVIDER || window.ethereum
}

export const config = createConfig({
  chains: [mainnet, polygon],
  connectors: [
    injected({
      target: {
        id: 'injected',
        name: 'Injected',
        provider: getSelectedInjectedProvider,
      },
    }),
  ],
  transports: {
    [mainnet.id]: http('https://mainnet.gateway.tenderly.co/7LSqXLbWQ8ykzNCqWL6kUR'),
    [polygon.id]: http('https://polygon.gateway.tenderly.co/6FaTAredZghGFTbrlpg0q7')
  }
})